<template>
  <div class="train-config-name-cell">
    <div>
      <v-chip :disabled="!train_config" @click="show_train_config_modal(train_config)" style="cursor: pointer">
        {{train_config.name}}
      </v-chip>
      <v-chip v-if="train_config.archived" size="x-small" class="ml-1" color="grey">
        {{ $t('models_and_train_configs.archived_badge') }}
      </v-chip>
      <v-btn
        v-if="train_config"
        icon
        variant="text"
        density="compact"
        size="x-small"
        class="train-config-secondary-action"
        @click.stop="copy_config()"
      >
        <v-icon size="small">far fa-copy</v-icon>
      </v-btn>
      <v-btn
        v-if="train_config"
        icon
        variant="text"
        density="compact"
        size="x-small"
        class="train-config-secondary-action"
        :title="train_config.archived ? $t('models_and_train_configs.unarchive') : $t('models_and_train_configs.archive')"
        :loading="archiving"
        :disabled="deleting"
        @click.stop="toggleArchive()"
      >
        <v-icon size="small">{{ train_config.archived ? 'mdi-archive-arrow-up' : 'mdi-archive' }}</v-icon>
      </v-btn>
      <v-btn
        icon
        variant="text"
        density="compact"
        size="x-small"
        class="train-config-secondary-action train-config-secondary-action--danger"
        :loading="deleting"
        :disabled="archiving"
        @click.stop="showDeleteConfirmationDialog()"
      >
        <v-icon size="small">far fa-trash-alt</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{$t('models_and_train_configs.card_headline_sure')}}</v-card-title>
          <v-card-text>
            {{$t('models_and_train_configs.card_text_warning')}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text :disabled="deleting" @click="dialog = false">{{$t('models_and_train_configs.cancel_button')}}</v-btn>
            <v-btn color="red darken-1" text :loading="deleting" @click="confirmDeleteConfigAndModels">{{$t('models_and_train_configs.confirm_button')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="archiveDialog" persistent max-width="360">
        <v-card>
          <v-card-title class="headline">{{$t('models_and_train_configs.archive_confirm_title')}}</v-card-title>
          <v-card-text>
            {{$t('models_and_train_configs.archive_confirm_text')}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="archiving" @click="archiveDialog = false">{{$t('models_and_train_configs.cancel_button')}}</v-btn>
            <v-btn color="primary" text :loading="archiving" @click="confirmArchive">{{$t('models_and_train_configs.confirm_button')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainConfigNameCell",
  props: {
    train_config: Object,
    models: Array,
    jobs: Array
  },
  components: {},
  data () {
    return {
      dialog: false,
      archiveDialog: false,
      archiving: false,
      deleting: false,
    }
  },
  methods: {
    setRowBusy(busy) {
      this.$emit('row-busy', busy);
    },
    show_train_config_modal(train_config) {
      this.$emit('show_train_config_modal', train_config)
    },
    copy_config() {
      this.$emit('copy_train_config', this.train_config);
    },
    async toggleArchive() {
      if (this.train_config.archived) {
        await this.unarchiveConfig();
        return;
      }
      if (this.related_models.length > 0) {
        this.archiveDialog = true;
        return;
      }
      await this.archiveConfig();
    },
    async confirmArchive() {
      await this.archiveConfig();
      this.archiveDialog = false;
    },
    async archiveConfig() {
      this.archiving = true;
      this.setRowBusy(true);
      try {
        await this.$api.train_config.archive(this.train_config);
        this.$emit('archived');
      } finally {
        this.archiving = false;
        this.setRowBusy(false);
      }
    },
    async unarchiveConfig() {
      this.archiving = true;
      this.setRowBusy(true);
      try {
        await this.$api.train_config.unarchive(this.train_config);
        this.$emit('archived');
      } finally {
        this.archiving = false;
        this.setRowBusy(false);
      }
    },
    async showDeleteConfirmationDialog() {
      if (this.related_models.length > 0) {
        this.dialog = true;
      } else {
        await this.deleteConfigAndModels();
      }
    },
    async confirmDeleteConfigAndModels() {
      await this.deleteConfigAndModels();
      this.dialog = false;
    },
    async deleteConfigAndModels() {
      this.deleting = true;
      this.setRowBusy(true);
      try {
        await this.$api.train_config.delete_train_config_and_related_models(this.train_config);
        this.$emit('load_items');
      } finally {
        this.deleting = false;
        this.setRowBusy(false);
      }
    },
  },
  computed: {
    related_active_jobs() {
      return this.jobs.filter(job => {
        const meta = JSON.parse(job.description);
        return meta.train_config_id === this.train_config.id && job.processed != 1;
      });
    },
    related_models() {
      if(!this.models) return [];
      return this.models.filter(model => model.train_config_id === this.train_config.id);
    },
  }
}
</script>

<style scoped>
.train-config-name-cell {
  position: relative;
  min-height: 32px;
}

.train-config-secondary-action {
  opacity: 0.4;
  min-width: 24px;
  width: 24px;
  height: 24px;
}

.train-config-secondary-action:hover {
  opacity: 0.85;
}

.train-config-secondary-action--danger:hover {
  color: rgb(var(--v-theme-error));
}
</style>
